import qs from 'query-string';

export const COURSELEAF_API_URL = '/courseleafapi/getcourse';

const { history, location } = window;

export function setQueryString(qsValue) {
  const newUrl = `${location.protocol}//${location.host}${location.pathname}${qsValue}`;
  history.replaceState({}, '', newUrl);
}

export function setQueryStringValue(key, value) {
  const queryString = location.search;
  const values = { ...qs.parse(queryString), [key]: value };
  const filteredValues =
    Object.entries(values).length > 0
      ? Object.entries(values).filter(([k, v]) => v)
      : [];
  const newQsValue = qs.stringify(Object.fromEntries(filteredValues));
  setQueryString(newQsValue ? `?${newQsValue}` : '');
}

export function getQueryStringValue(key) {
  const queryString = location.search;
  const values = qs.parse(queryString);
  return values[key];
}

export function getHash(url) {
  let hash = '';
  const hashStart = url.indexOf('#');
  if (hashStart !== -1) {
    hash = url.slice(hashStart);
  }

  return hash;
}

function removeHash(input) {
  const hashStart = input.indexOf('#');
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }

  return input;
}

export function stringifyUrl(input, options) {
  const url = removeHash(input.url).split('?')[0] || '';
  const queryFromUrl = qs.extract(input.url);
  const parsedQueryFromUrl = qs.parse(queryFromUrl);
  const hash = getHash(input.url);
  const query = Object.assign(parsedQueryFromUrl, input.query);
  let queryString = qs.stringify(query, options);
  if (queryString) {
    queryString = `?${queryString}`;
  }

  return `${url}${queryString}${hash}`;
}

export const isExternalLink = (url) => {
  const tmp = document.createElement('a');
  tmp.href = url;
  return tmp.host !== window.location.host;
};
